export default __webpack_public_path__ + "static/media/campaignmonitor.7063484f.png";